export const nspdArticle = {
    id: 'nspd-module',
    title: 'Модуль НСПД',
    category: 'Модули расширения',
    requiredModule: 'nspd-integration',
    summary: 'Автоматическая загрузка кадастровых границ, площадей и контуров зданий из Публичной кадастровой карты Росреестра (НСПД).',
    markdown: `
> **Модуль НСПД** — это прямая интеграция вашей карты с официальной базой **Росреестра** (Национальной системой пространственных данных). Он позволяет не обводить участки и здания вручную, а автоматически загружать их точные юридические границы, официальные площади и адреса по кадастровым номерам.

---

## 1. Для чего нужен модуль?

:::grid cols=3
:::card icon="download" title="Мгновенный импорт"
Загружайте точные контуры участков и зданий по кадастровому номеру, списку номеров или целому кадастровому кварталу.
:::

:::card icon="refresh-cw" title="Сверка актуальности"
В один клик проверяйте, не изменились ли границы или площади ваших участков в официальном Росреестре.
:::

:::card icon="crosshair" title="Поиск по клику"
Кликните на любое место на карте — модуль сам определит координаты и найдет кадастровый участок под курсором.
:::
:::

---

## 2. Три вкладки Мастера НСПД

При открытии модуля слева доступны 3 удобных режима работы:

:::grid cols=1
:::card icon="layers" title="1. Вкладка «Импорт» (Поиск и пакетная загрузка)"
Основная вкладка для добавления новых объектов на карту. Доступно 4 способа:

* **По одному номеру:** введите кадастровый номер (например, \`23:49:0101001:123\`) и нажмите **«Найти объекты»**.
* **Списком номеров:** вставьте перечень кадастровых номеров через запятую или с новой строки — система опросит их все разом.
* **По номеру квартала:** введите номер кадастрового квартала (например, \`23:49:0101001\`), и система просканирует и загрузит все участки квартала в потоковом режиме с живым прогресс-баром.
* **Из ZIP-архива выписок:** нажмите **«Загрузить архив выгрузки (ZIP)»**, чтобы модуль сам извлек все кадастровые номера из официального архива Росреестра.

После поиска в таблице результатов нажмите **«Импорт»** напротив нужного объекта или кнопку **«Импорт новых»** для сохранения всех найденных участков на карту.
:::

:::card icon="check-circle" title="2. Вкладка «Объекты» (Сверка и обновление базы)"
В этой вкладке собраны все объекты, которые уже сохранены на вашей карте и имеют кадастровый номер.

* **Кнопка «Проверить обновления»:** система по очереди опрашивает Росреестр и сверяет текущую площадь, контуры и категорию каждого объекта.
* **Индикаторы состояния:**
  * 🟢 **Актуально** — данные на вашей карте полностью совпадают с Росреестром.
  * 🟡 **Бейдж изменений (например, *«Площадь: 600 -> 650»*)** — в Росреестре появились свежие данные или изменились границы.
* **Кнопка «Применить все обновления»:** в один клик обновляет геометрию и характеристики всех изменившихся объектов.
:::

:::card icon="crosshair" title="3. Вкладка «Поиск на карте» (Точечный клик)"
Удобный инструмент для полевой работы и быстрой разведки территории:

1. Нажмите кнопку **«Указать точку на карте»**.
2. Кликните левой кнопкой мыши в любое место карты.
3. Модуль мгновенно отправит географические координаты в НСПД и покажет карточку участка или здания, расположенного в этой точке (кадастровый номер, адрес, площадь и статус в вашей базе).
4. Если объекта еще нет на карте — нажмите **«Импортировать на карту»**. Если он уже есть — система покажет наглядное сравнение (дифф) и предложит обновить данные.
:::
:::

---

## 3. Простые пошаговые сценарии

### Сценарий А: Быстро оцифровать целый поселок по кадастровым номерам
1. Откройте **Модуль НСПД** и перейдите во вкладку **«Импорт»**.
2. Вставьте список кадастровых номеров в текстовое поле (или укажите номер кадастрового квартала).
3. Нажмите **«Найти объекты»** и дождитесь завершения поиска.
4. Нажмите кнопку **«Импорт новых»** — все участки с точными границами появятся на карте.

### Сценарий Б: Узнать информацию об участке прямо на карте
1. Перейдите во вкладку **«Поиск на карте»** (или нажмите «Указать точку на карте»).
2. Кликните на нужный контур местности.
3. Ознакомьтесь с официальным кадастровым номером, площадью и адресом, затем нажмите **«Импортировать на карту»**.
`
};

